import { Interval } from '@shared/utils/History/Interval';
import { TimeSpanPeriods } from '@shared/utils/Time/TimeSpan';
import { HistoryMerger } from './HistoryMerger';
import { Decimal } from 'decimal.js';
export class HistoryMergerBasedByMin extends HistoryMerger {
    constructor(inputParams) {
        super(inputParams);
    }
    FindIntervalBorders(date) {
        const interval = this.GetStartPoint(date);
        const startPointUtc = interval.From;
        const maxEndUtc = interval.To;
        const borders = this.GetPropagatedBarBorders(date, startPointUtc, this.newPeriod);
        // корректируем правую границу бара в соответствии с ограничениями
        if (borders.To > maxEndUtc) {
            borders.To = maxEndUtc;
        }
        // hsa: бар не попадает в нужный диапазон
        // например при интрадей агрегации для сессии возможно будет бар, который
        // попадает за границы сессии в которых ведется агрегация
        if (date < borders.From || date >= borders.To) {
            return Interval.GetInvalidInterval();
        }
        return borders;
    }
    GetPropagatedBarBorders(timeUtc, startTime, newPeriod) {
        // на текущий момент это копипаста метода из CashItem.FindStartData
        const data = timeUtc.getTime() - startTime.getTime();
        const barLength = newPeriod * TimeSpanPeriods.TicksPerMinute;
        // how many bars since start time?
        const periodsCountFractional = new Decimal(data).div(barLength);
        const periodsCount = periodsCountFractional.trunc().toNumber();
        const barStartInTicks = startTime.getTime() + periodsCount * barLength;
        const barEndInTicks = barStartInTicks + barLength;
        const interval = new Interval();
        interval.From = new Date(barStartInTicks);
        interval.To = new Date(barEndInTicks);
        return interval;
    }
}
